// TODO = replace all runtime checks/types with this enum
export enum AppRuntimes {
    returnista = "ios",
    returnPortal = "return-portal",
    staples = "staples",
}
